module.exports = __webpack_public_path__ + "static/media/Employer_branding_1_B.f41609a4.png";